import { Form, Formik } from 'formik';
import PropTypes from 'prop-types';
import { ImCross } from 'react-icons/im';
import { object, string } from 'yup';
import { Button, Input, ModalComponent } from '../../../common/components';
import { ACTION_EDIT, ACTION_NEW } from '../../../constants/gl-configuration';
import { accountTypeRegex } from '../../../constants/regex';

const AddAccountTypeModal = ({ isOpen, toggle, section, onSubmit, selectedValue, action }) => {
  const NewAccountModal = () => {
    return (
      <div className="add-account-modal">
        <div className="close-btn">
          <ImCross color="#D38529" onClick={toggle} />
        </div>
        <div className="add-modal-header">{`${action} ${section}`}</div>
        <Formik
          initialValues={{ title: selectedValue || '' }}
          validationSchema={object({
            title: string()
              .trim()
              .required(`${section} name is required`)
              .matches(
                accountTypeRegex,
                `${section} must be 2 to 60 characters long and alphabet only`,
              ),
          })}
          onSubmit={onSubmit}
        >
          {({ handleSubmit, values }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <div>
                  <Input
                    formInput
                    name="title"
                    type="text"
                    className="Account-input"
                    placeholder={`${section} Name`}
                  />
                </div>
                <div className="atd-modal-btns">
                  <Button
                    color="primary"
                    className="save-atd-btn"
                    size="xs"
                    type="submit"
                    disabled={values.title === selectedValue}
                  >
                    Save
                  </Button>
                  <Button className="cancel-atd-btn" size="xs" onClick={toggle}>
                    Cancel
                  </Button>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    );
  };

  return (
    <ModalComponent isOpen={isOpen} toggle={toggle} className="EmailModalWrapper">
      {NewAccountModal()}
    </ModalComponent>
  );
};

AddAccountTypeModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  section: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  selectedValue: PropTypes.string,
  action: PropTypes.oneOf([ACTION_NEW, ACTION_EDIT]),
};

AddAccountTypeModal.defaultProps = {
  selectedValue: '',
  action: ACTION_NEW,
};

export default AddAccountTypeModal;
